import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Testimonials from "./Testimonials";

import undrawMale from "../assets/undraw_male.svg";
import undrawFemale1 from "../assets/undraw_female_1.svg";
import undrawFemale2 from "../assets/undraw_female_2.svg";
import undrawFemale3 from "../assets/undraw_female_3.svg";

function TestimonialsSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        <Testimonials
          items={[
            {
              avatar: undrawMale,
              name: "Calvin Cox",
              quote:
                "Jason has been instrumental in building out components, testing code, and streamlining interfaces for this effort. Jason is a dedicated learner and continues to impress me with his ability to pick up new frameworks, libraries, and technologies.",
              company: "Engineering Manager @Earnin",
            },
            {
              avatar: undrawFemale1,
              name: "Stephanie Egan",
              quote:
                "Jason is eager to learn, curious and extremely empathetic to customers and support agents alike. In a nutshell, Jason is a very hardworking, collaborative and user-centric frontend developer and I felt very lucky to have the privilege to work alongside him at Earnin.",
              company: "Product Manager @Earnin",
            },
            {
              avatar: undrawFemale2,
              name: "Katie Carrel",
              quote:
                "Jason is a forward thinking and hardworking leader who is a great addition to any team he is a part of. He has an eye for beautiful design and implementing great UI. Jason would bring professionalism, emotional intelligence and a hardworking attitude to any company that is lucky to have him.",
              company: "Systems Engineer @Gravitational",
            },
            {
              avatar: undrawFemale3,
              name: "Lucy Suddenly",
              quote:
                "Jason is an outstanding developer, endlessly thoughtful and detail-oriented. I’m consistently impressed by his eye for design and his ability to execute to achieve his vision. Any company that hires Jason should consider themselves lucky. His leadership skills will ensure that he’ll be my boss someday, and maybe yours too.",
              company: "Site Reliability Engineer @Outreach.io",
            },
          ]}
        ></Testimonials>
      </div>
    </Section>
  );
}

export default TestimonialsSection;
